import { ThemeProvider } from "next-themes";
import { SessionProvider } from "next-auth/react";
import "../css/tailwind.css";
import { GlobalProvider } from '../context/GlobalContext';
import WidgetLoader from '../components/common/WidgetLoader';
import Head from "next/head";
import env from '../config/env';

function MyApp({ Component, pageProps: { session, ...pageProps } }) {
  // Console logging utility that respects environment
  const isProduction = env.clusterEnv === 'PROD';

  // Override global console methods in production (both client and server)
  if (isProduction) {
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
    console.warn = () => {};
    // Keep console.error for critical errors even in production
    // console.error = () => {};
  }

  return (
    <GlobalProvider>
      <Head>
        <title>Generate Residential Purchase Agreement</title>
        <meta
          name="description"
          content="AI-Powered Transaction Coordination Services for Real Estate Agents."
        />
        <link rel="icon" href="/favicon.ico" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
          rel="stylesheet"
        />
      </Head>
      <SessionProvider session={session}>
        <ThemeProvider attribute="class">
          <Component {...pageProps} />
        </ThemeProvider>
      </SessionProvider>
      <WidgetLoader />
    </GlobalProvider>
  );
}

export default MyApp;
